// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px) and (min-width: 601px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "root-x8-7E";
var _5 = "summary-1rU_m";
var _6 = "details-2A32U";
var _7 = "heading-1AqLE";
var _8 = "expandIcon-22fof";
export { _1 as "__esModule", _2 as "tablet_only", _3 as "mobile", _4 as "root", _5 as "summary", _6 as "details", _7 as "heading", _8 as "expandIcon" }
export default { "__esModule": _1, "tablet_only": _2, "mobile": _3, "root": _4, "summary": _5, "details": _6, "heading": _7, "expandIcon": _8 }
